"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Fade = _interopRequireDefault(require("../fade/Fade"));

var DataTab = function DataTab(_ref) {
  var disableTransition = _ref.disableTransition,
      children = _ref.children,
      active = _ref.active,
      mountOnEnter = _ref.mountOnEnter,
      unmountOnExit = _ref.unmountOnExit;
  var content = disableTransition ? /*#__PURE__*/_react.default.createElement("div", null, active && children) : /*#__PURE__*/_react.default.createElement(_Fade.default, {
    in: active,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }, /*#__PURE__*/_react.default.createElement("div", null, active && children));
  return content;
};

DataTab.defaultProps = {
  active: false,
  disableTransition: false
}; // Props are injected from the wrapping DataTabs component

DataTab.propTypes = {
  mountOnEnter: _propTypes.default.bool,
  unmountOnExit: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = DataTab;
exports.default = _default;